const $inject = [
    "$state",
    "$uibModalInstance",
    "HmrService",
    "eCryptService",
    "product_prices",
    "patientName"
];

class HmrSubmitModalController {
  /**
   * @constructor
   * @param $state
   * @param $uibModalInstance
   * @param HmrService
   * @param eCryptService
   * @param product_prices
   * @param patientName
   */
  constructor(
    $state,
    $uibModalInstance,
    HmrService,
    eCryptService,
    product_prices,
    patientName
  ) {
    this.$state = $state;
    this.$uibModalInstance = $uibModalInstance;
    this.hmrService = HmrService;
    this.eCryptService = eCryptService;

    this.product_prices = product_prices;
    this.patientName = patientName;

    this.cvn = null;

    // Load the public key for encrypting the CVN
    this.clientSideKey = null;
    this.getClientSideKey();

    // Get the eCrypt encrypting functions (should already be loaded in the HmrController but will check anyway)
    this.eCryptService.load();
  }

  /**
   * Submit HMR
   * @param form
   */
  submit(form) {
    this.submitted = true;
    if (form.$valid) {
      this.loading = true;
      this.$uibModalInstance.close(eCrypt.encryptValue(this.cvn, this.clientSideKey));
    }
  }

  /**
   * Close the modal
   */
  cancel() {
    this.$uibModalInstance.dismiss("cancel");
  }

  getClientSideKey() {
    var self = this;

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.clientSideKey = response.data.data.clientSideKey;
        self.errorMessage = response.data.message;
        self.extraMessage = response.data.data.message;
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      //TODO: define error behaviour
    };

    this.hmrService.getClientSideKey(handleSuccess, handleError);
  }
}

HmrSubmitModalController.$inject = $inject;

export default HmrSubmitModalController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/controllers/modals/submit.controller.js
 **/